import React from 'react';
import {rootStore} from './rootStore';

export const storeContext = React.createContext(rootStore);